export interface OidcCallbackParams {
  token: string;
  userId: string;
  sessionId: string;
  /** IdP account id (OIDC sub); optional so older backends keep working. */
  sub?: string;
}

/** Parse the OIDC redirect fragment (#token=..&user_id=..&session_id=..&sub=..). Returns null if incomplete. */
export function parseOidcCallback(hash: string): OidcCallbackParams | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const p = new URLSearchParams(raw);
  const token = p.get("token");
  const userId = p.get("user_id");
  const sessionId = p.get("session_id");
  if (!token || !userId || !sessionId) return null;
  const sub = p.get("sub");
  return { token, userId, sessionId, ...(sub ? { sub } : {}) };
}
